'use strict';
var foreach = require('./foreach'),
    $ = require('jquery'),
    ObservableList = require('./observable-list');

/**
 * Tell an object to listen to a particular event on an other object.
 * The advantage of using this form, instead of other.on(event, callback),
 * is that listenTo allows the object to keep track of the events,
 * and they can be removed all at once later on.
 *
 * @param {object} observable
 * @param {string} evtName
 * @param {Function} cb
 */
function listenTo(observable, evtName, cb) {
    /*jshint validthis:true */
    var listeners = this._observed || (this._observed = new ObservableList());

    listeners.add(observable, evtName, this.cid, cb);
}

/**
 * Make an object observable, binding to him 'on', 'off', 'one' and 'trigger'
 * methods from @param $el
 *
 * @param {object} obj
 * @param {jQuery} $el
 */
function makeObservable(obj, $el) {
    $el = $el || $({});

    foreach(['on', 'off', 'one', 'trigger'], function (method) {
        /**
         * Binding function
         */
        obj[method] = function binding() {
            $el[method].apply($el, arguments);
        };
    });

    obj.listenTo = listenTo;
}

module.exports = makeObservable;
